<template>
  <NavigationHeader :title="wp.title" />
</template>

<script>
export default {
  name: 'PublicationsHeader',
  inject: ['wp']
}
</script>
